import { CSSProperties, useState } from "react";
import { defineMessages, useIntl } from "react-intl";
import Skeleton from "react-loading-skeleton";
import { IconCameraX, IconLock } from "@tabler/icons-react";
import { classNames } from "@ct-react/core";
import { Image, isSaleArticle } from "@shared/graphql";
import { SkeletonableProps } from "../../tools/components";
import RatioImage from "../medias/ratio-image";
import Button from "../common/button";
import FullScreenCarousel from "../carousel/carousel-full-screen";
import SpriteSvg from "../common/svg";
import { card } from "../article-card";

import "./images.scss";

const transDefs = defineMessages({
  gallery: { id: "article.gallery-link", defaultMessage: "{count, plural, =1 {photo} other {# photos}}"}
});

const ImagesPart = ({ className, loading, data, images }: SkeletonableProps<Image[]>) => {

  const intl = useIntl();
  const [fullScreenOpen, setFullScreenOpen] = useState<boolean>(false);
  const wrapperClasses = classNames("images-part", className, {
    "no-image": !!data && data.length === 0
  });

  if (loading || !images)
    return (
      <div className={wrapperClasses}>
        <Skeleton containerClassName="previews" inline={true} count={5} className="preview-img"  />
      </div>);

  return (
    <>
      <div className={wrapperClasses}>
          <ul className="badges">
            {(isSaleArticle(data) && data.sold) &&
              <li>
                <IconLock className="b-icon" />
                {intl.formatMessage(card.sold)}
              </li>
            }
          </ul>
        <div className="previews">
          {images.length > 0
            ? images.slice(0, 5).map((img:any, index:number) =>
              <RatioImage key={index} className="preview-img" ratio="3/2" source={img.assets} />)
            : <IconCameraX className="x-icon" />
          }
        </div>
        <div className="btns">
          {images.length > 0 &&
            <Button className="outline with-icon" onClick={() => setFullScreenOpen(true)}>
              <SpriteSvg id="image"/>
              {intl.formatMessage(transDefs.gallery, { count: images.length })}
            </Button>
          }
        </div>
      </div>
      {(!loading && images) && <FullScreenCarousel images={images} opened={fullScreenOpen} setFullScreenOpen={setFullScreenOpen}/>}
    </>);

}

export default ImagesPart;
